<template>
    <footer id="footer">
        <div class="form">
            <div class="form_container">
                <h2 class="title">
                    Let's get started
                </h2>
                <p>
                    Please fill out the form below and we'll reach out soon. <br><br>
                    If you'd like to connect immediately, please phone Austin Robbins at <a href="tel:+7057123227‬">705.712.3227‬</a> or email
                    <a href="mailto:austin@uptowncreative.io">austin@uptowncreative.io</a>.
                </p>
                <form
                    name="contact"
                    method="post"
                    data-netlify="true"
                    data-netlify-honeypot="bot-field"
                    @submit.prevent="handleSubmit">
                    <input type="hidden" name="form-name" value="contact" />
                    <div class="form_elements">
                        <div class="inputs">
                            <input type="text" name="name" placeholder="Name" v-model="form.name">
                            <input type="text" name="email" placeholder="Email*" v-model="form.email" required>
                            <input type="text" name="phone" placeholder="Phone" v-model="form.phone">
                        </div>
                        <textarea name="message" cols="30" rows="10" placeholder="Message"  v-model="form.message"></textarea>
                    </div>
                    <button type="submit" class="small_title">
                        Send request
                    </button>
                </form>
            </div>
        </div>
        <div class="credits">
            <img src="/images/footer-logo.svg" alt="" />
            <p>Copyright © 2021 Uptown Creative, Inc. <router-link to="/privacy-policy">Privacy Policy</router-link></p>
        </div>
    </footer>  
</template>

<script>

export default {
    name: "Footer",
    methods: {
        encode (data) {
            return Object.keys(data)
                .map(
                key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
                )
                .join("&");
        },
        handleSubmit () {
            const axiosConfig = {
                header: { "Content-Type": "application/x-www-form-urlencoded" }
            };
            const self = this;
            this.axios.post("/",
                this.encode({
                    "form-name": "contact",
                    ...this.form
                }),
                axiosConfig
            )
            .then(() => {
                self.$fire({
                    title: "Success",
                    text: "We have received your message, we will contact you shortly.",
                    type: "success",
                    timer: 3000
                });
                self.form.name = '';
                self.form.email = '';
                self.form.phone = '';
                self.form.message = '';
            })
            .catch(() => {
                self.$fire({
                    title: "Error",
                    text: 'Error submitting form data, please try again.',
                    type: "error",
                    timer: 2500
                })
            })
        }
    },
    data(){
        return{
            form:{
                name: '',
                email: '',
                phone: '',
                time_to_call: '',
                message: ''
            },
            socialMediaItems: [
                {
                    icon: 'instagram',
                    url:"https://www.instagram.com/",
                },
                {
                    icon: 'twitter-square',
                    url:"https://www.instagram.com/",
                },
                {
                    icon: 'linkedin',
                    url:"https://www.instagram.com/",
                },
                {
                    icon: 'facebook-square',
                    url:"https://www.facebook.com/",
                },
                
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
#footer{
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .form{
        background: rgba($color: #f7f7f7, $alpha: 1.0);
        width: 100%;
        padding: 4rem 0;
        p{
            margin: 1.5rem 0;
        }
    }
    .form_container{
        margin: 4rem auto 2rem;
        max-width: 700px;
    }
    .form_elements{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin: 3rem auto;
        .inputs{
            width: 40%;
            display: flex;
            flex-direction: column;
            margin-right: 3rem;
            input{
                border: none;
                border-bottom: 1px solid #cccccc;
                background: #f7f7f7;
                height: 3rem;
                margin: 0.4rem 0;
                padding-left: 10px;
                padding-top: 10px;
                padding-bottom: 10px;
                font-size: 17.8px;
                letter-spacing: 1.5px;
                line-height: 28px;
                font-weight: 400;
                color: #727272;
                &::placeholder {
                    font-size: 17.8px;
                    letter-spacing: 1.5px;
                    line-height: 28px;
                    font-weight: 400;
                    color: #727272;
                }
                &:focus{
                    border: none;
                    outline: 1px solid #727272;
                }
            }
        }
        textarea{
            flex: 1;
            border: 1px solid #cccccc;
            background: #f7f7f7;
            font-size: 17.8px;
            letter-spacing: 1.5px;
            line-height: 28px;
            font-weight: 400;
            height: 180px;
            color: #727272;
            font-family: 'forma-djr-banner', sans-serif;
            padding: 10px;
            &::placeholder {
                font-size: 17.8px;
                letter-spacing: 1.5px;
                line-height: 28px;
                font-weight: 400;
                color: #727272;
            }
        }
    }
    a{
        font-weight: 500;
    }
    button{
        margin: 1rem auto;
        padding: 12px 20px;
    }
    img{
        margin: 0;
        height: 41px;
    }
    .credits{
        margin: 2rem 0;
        margin-top: 3rem; 
        p{
            margin: 1rem 0;
            font-size: 9px;
            color: #9b9b9b;
        }
        a{
            font-weight: 400;
            color: #9b9b9b;
        }
    }
}

@media (max-width: $mobile) { 
    #footer{
        flex-wrap: wrap;
        &>div{
            width: 100%;
        }
        .form{
            padding: 77px 0;
        }
        .form_container{
            margin: 0 2rem;
            p{
                margin: 1rem 0 77px;
            }
        }
        .form_elements{
            .inputs{
                width: 100%;
                margin-right: 0;
                input{
                    border: 1px solid #cccccc;
                    height: 2rem;
                    margin: 0.75rem 0;
                    padding-left: 10px;
                    padding-top: 10px;
                    padding-bottom: 10px;
                }
            }
            textarea{
                margin-top: 1rem;
                padding-left: 10px;
                padding-top: 10px;
                padding-bottom: 10px;
            }
        }
    }
}
</style>